"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/PetrolCan.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PetrolCan = function PetrolCan(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 203.65 102.88"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Petrol Can Icon"), _react2.default.createElement("path", {
    className: "petrol-can",
    d: "M203.28 18.98c-.9-4-6.1-10-9-13.1a3.93 3.93 0 0 0-.6-4.6 4 4 0 0 0-5.3-.5l-58.7 42.1v-2.7a9.86 9.86 0 0 0-9.9-9.9h-33.3v-9h16.2v-8h-16.2v-6h-5v6h-16.4v8h16.4v9h-16.5l-38.3-26.9-.2-.2-.3-.1a8.62 8.62 0 0 0-6.5-.4 7.93 7.93 0 0 0-4.9 4.4l-14 29.7a8.4 8.4 0 0 0-.2 6.6 8 8 0 0 0 4.4 4.6l21.9 10.4v34.6a9.92 9.92 0 0 0 9.9 9.9h83.1a9.84 9.84 0 0 0 9.9-9.8v-12.4l57.2-66.2c-.6 3.1-.9 6.2-.4 8.3a13.17 13.17 0 0 0 4 6.8 8 8 0 0 0 5.1 2.1 11 11 0 0 0 1.8-.2c4.5-1 7.2-6.6 5.8-12.5zm-176.4 21.1v10.7l-19-9a1.82 1.82 0 0 1-1-1.1 1.28 1.28 0 0 1 0-1.2l14-29.6a1.27 1.27 0 0 1 .9-.7 2.85 2.85 0 0 1 1.3 0l30 21.1h-16.3a9.71 9.71 0 0 0-9.9 9.8zm95.8 36.6a4 4 0 0 0-1 2.6v13.7a1.79 1.79 0 0 1-1.8 1.8h-83.1a1.88 1.88 0 0 1-1.9-1.8v-52.9a2 2 0 0 1 1.9-1.9h83.1a2 2 0 0 1 1.9 1.9v10.5a4 4 0 0 0 4 4 4.76 4.76 0 0 0 2.3-.7l35.6-25.4zm73.9-48.4a4.63 4.63 0 0 1-3.9-1.2 9.13 9.13 0 0 1-2.9-5c-.7-2.8.8-9 2-13.3l.3-.3c3 3.3 7.2 8.3 7.8 11.3 1 4-.5 7.9-3.3 8.5z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = PetrolCan;